export default angular
  .module('filters.formatTime', [])

  .filter(
    'formatTime',
    () =>
      function(quantity, unit) {
        switch (unit) {
          case 'day':
          case 'days':
            switch (false) {
              case Math.abs(quantity) !== 1:
                return `${quantity} day`;
              default:
                return `${quantity} days`;
            }
          default:
            throw new Error(`Unit ${unit} not supported`);
        }
      },
  );
